<template>
  <a-spin :spinning="confirmLoading" class="overhaul-task-dialog">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务日期" prop="taskDate">
              <j-date placeholder="请选择任务日期" style="width: 100%" v-model="model.taskDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" prop="manager">
              <j-dict-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                pageSize="100"
                placeholder="请选择负责人"
                type="list"
                v-model="model.manager"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内部执行人员" prop="internalExecutor">
              <j-multi-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                placeholder="内部执行人员"
                v-model="model.internalExecutor"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="外聘执行人员" prop="externalExecutor">
              <a-input placeholder="请输入外聘执行人员" v-model="model.externalExecutor"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="日常检修项目">
        <j-vxe-table
          :columns="ywDailyOverhaulItem.columns"
          :dataSource="ywDailyOverhaulItem.dataSource"
          :disabled="formDisabled"
          :linkage-config="linkageConfig"
          :loading="ywDailyOverhaulItem.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
          :toolbar="true"
          @edit-closed="handleEditClosed"
          keep-source
        >
          <template v-slot:action="props">
            <a @click="addBpbj(props)" v-if="props.row.devId">添加</a>
          </template>
        </j-vxe-table>
      </a-tab-pane>
    </a-tabs>
    <!-- 消耗备品备件列表 -->
    <DevBpbjLeadoutRecordList :canEdit="true" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
    <!-- 选择备品备件list -->
    <DevBpbjInfoList :title="deviceName" @refresList="refresList" ref="DevBpbjInfoList" taskTable="overhaul"></DevBpbjInfoList>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JVxeTableModelMixin } from '@/mixins/JVxeTableModelMixin.js'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { getRefPromise, VALIDATE_FAILED } from '@/components/jeecg/JVxeTable/utils/vxeUtils.js'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import moment from "dayjs";
  import DevBpbjInfoList from '@/views/eMaintenance/modules/DevBpbjInfoList'
  import DevBpbjLeadoutRecordList from '@/views/eMaintenance/modules/DevBpbjLeadoutRecordList'
  import { omit } from 'lodash'

  export default {
    name: 'YwDailyOverhaulTaskForm',
    mixins: [JVxeTableModelMixin],
    components: {
      JFormContainer,
      DevBpbjInfoList,
      DevBpbjLeadoutRecordList
    },
    data () {
      return {
        deviceName: '',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        model: {
          taskDate: moment().format('YYYY-MM-DD'),
          //manager默认当前登录人
          manager: this.$store.getters.userInfo.id,
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          taskDate: [
            { required: true, message: '请输入任务日期!' },
          ],
          manager: [
            { required: true, message: '请输入负责人!' },
          ],
        },
        refKeys: ['ywDailyOverhaulItem',],
        tableKeys: ['ywDailyOverhaulItem',],
        activeKey: 'ywDailyOverhaulItem',
        // 日常检修项目
        // 联动配置
        linkageConfig: [
          { requestData: this.getDevlistByProcess, key: 'devProcessId', },
        ],
        ywDailyOverhaulItem: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '供水流域',
              key: 'devProcessId',
              type: JVXETypes.selectSearch,
              dictCode: "`iwt-wf`.dev_process,process_name,id, del_flag = '0' order by sort",
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              // 联动字段（即下一级的字段）
              linkageKey: 'devId',
            },
            {
              title: '设备',
              key: 'devId',
              type: JVXETypes.select,
              width: "300px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '设备Name',
              key: 'devName',
              type: JVXETypes.hidden,
              placeholder: '请选择${title}',
              defaultValue: '',
            },
            {
              title: '工作内容',
              key: 'workContent',
              type: JVXETypes.textarea,
              minWidth: "300px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: '备件消耗',
              key: 'action',
              type: JVXETypes.slot,
              width: "120px",
              align: 'center',
              slotName: 'action',
            },
          ]
        },
        url: {
          add: "/maintenance/overhaul/add",
          edit: "/maintenance/overhaul/edit",
          queryById: "/maintenance/overhaul/queryById",
          ywDailyOverhaulItem: {
            list: '/maintenance/overhaul/queryYwDailyOverhaulItemByMainId'
          },
          devList: '/device/devList/list',
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      this.modelDefault = JSON.parse(JSON.stringify(this.model))

    },
    mounted () {
      this.$refs.ywDailyOverhaulItem.handleRecalculateTable()
    },
    methods: {
      async handleEditClosed (rows) {
        // devId
        const { column, row } = rows
        console.info('c====', column, rows)
        if (column.key == "devId") {
          const { success, result } = await getAction('/device/devList/queryById', { id: row.devId })
          if (success) {
            const { devName = '' } = result

            this.$refs.ywDailyOverhaulItem.setValues([
              {
                rowKey: row.id,
                values: {
                  devName
                }
              },
            ])
          }
        }
      },
      addBpbj (props) {
        const row = props.row;
        this.deviceName = row?.devName ? `${row?.devName}：消耗备件` : '消耗备件'
        this.$refs.DevBpbjInfoList.open(row)
      },
      // 刷新已消耗的备品备件list
      refresList (list) {
        const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
      },

      addBefore () {
        this.ywDailyOverhaulItem.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => {
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.ywDailyOverhaulItem.list, params, this.ywDailyOverhaulItem)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_FAILED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue);
        return {
          ...main, // 展开
          ywDailyOverhaulItemList: allValues.tablesValue[0].tableData,
          bpbjLeadoutList: this.$refs.devBpbjLeadoutRecordList.dataSource.map(map => {
            map.bjModelId = map.id;
            omit(map, ['id']);
            return map;
          })
        }
      },
      handleFinish () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!that.model.id) {
              httpurl += that.url.add;
              method = 'post';
            } else {
              httpurl += that.url.edit;
              method = 'put';
            }
            const tableData = that.$refs[that.refKeys[0]].getTableData();

            const bpbjLeadOutList = that.$refs.devBpbjLeadoutRecordList.dataSource.map(map => {
              map.bjModelId = map.id;
              omit(map, ['id']);
              return map;
            });
            // 整理成formData
            let formData = Object.assign(that.model, {
              finishTime: moment().format('YYYY-MM-DD HH:mm:ss'),
              taskStatus: 1,
              finishPerson: that.model.manager,
              ywDailyOverhaulItemList: tableData.map(item => {
                item.isExecute = 'Y';
                return item
              }),
              bpbjLeadoutList: bpbjLeadOutList
            });

            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            });
          }

        })
      },
      validateError (msg) {
        this.$message.error(msg)
      },
      async getDevlistByProcess (parent) {
        let res
        // 如果parent为空，则查询第一级菜单
        if (parent === '') {
          res = await getAction(this.url.devList, {
            column: 'sort',
            order: 'asc',
            pageNo: 1,
            pageSize: 1000
          });
        } else {
          res = await getAction(this.url.devList, {
            devProcessId: parent, column: 'sort',
            order: 'asc',
            pageNo: 1,
            pageSize: 1000
          })
        }
        if (res.success) {
          // 返回的数据里必须包含 value 和 text 字段
          return res.result.records.map(item => ({ value: item.id, text: item.devName }))
        }
        return []
      },
    }
  }
</script>

<style scoped lang='less'>
  .overhaul-task-dialog {
    /deep/ .ant-card-body {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>